export default "__VITE_ASSET__40f311ba__"